module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point02_01_miyakoblue-2f8455b52318d65bd5f258ab0a84980d.jpg";